import styles from "~/styles/burn-rate.module.css";

interface FoodCostCardProps {
  pct: number;
  health: "good" | "warn" | "bad";
}

export function FoodCostCard({ pct, health }: FoodCostCardProps) {
  const color = health === "good" ? "#34C759" : health === "warn" ? "#FF9500" : "#FF3B30";
  const message =
    health === "good"
      ? "Saludable"
      : health === "warn"
      ? "Revisar"
      : "Crítico";

  return (
    <div className={styles.chartCard}>
      <p className={styles.chartTitle}>Food Cost</p>
      <div className={styles.foodCostContent}>
        <svg width="64" height="64" viewBox="0 0 64 64" className={styles.foodCostRing}>
          <circle cx="32" cy="32" r="26" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="5" />
          <circle
            cx="32"
            cy="32"
            r="26"
            fill="none"
            stroke={color}
            strokeWidth="5"
            strokeLinecap="round"
            strokeDasharray={`${(pct / 100) * 163.36} ${163.36}`}
            strokeDashoffset="-40.84"
            style={{ transition: "stroke-dasharray 0.6s ease" }}
          />
        </svg>
        <div className={styles.foodCostText}>
          <span className={styles.foodCostValue} style={{ color }}>{pct.toFixed(0)}%</span>
          <span className={styles.foodCostStatus} style={{ color }}>{message}</span>
        </div>
      </div>
    </div>
  );
}
